import { Link } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import type { Platform, ShelfHealth } from "../api/generated/model";
import { ago } from "../api/labels";
import { platformLabel } from "../api/platforms";

export function RankPlatformMeasurement({ platform, keyword, health }: {
  platform: Platform;
  keyword: string;
  health?: ShelfHealth;
}) {
  if (!health) return <span className="text-xs text-ink-2">Not measured</span>;
  const unanswered = health.probes - health.answered;
  return (
    <Link
      to={`/rank/keywords/${encodeURIComponent(keyword)}?platform=${platform}`}
      aria-label={`Open ${platformLabel(platform)} measurements for ${keyword}`}
      className="flex w-full flex-col gap-0.5 rounded-sm py-2 text-xs text-ink-2 no-underline hover:text-brand focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-brand"
    >
      <span><strong className="font-mono font-medium text-ink tabular-nums">{health.placements.toLocaleString("en-IN")}</strong> placements</span>
      <span className="flex items-center gap-2" title={`${health.answered.toLocaleString("en-IN")} of ${health.probes.toLocaleString("en-IN")} probes answered`}>
        <span><span className="font-mono tabular-nums">{health.answered.toLocaleString("en-IN")} / {health.probes.toLocaleString("en-IN")}</span> answered</span>
        {unanswered > 0 && <span className="inline-flex items-center gap-1 text-warning" title={`${unanswered.toLocaleString("en-IN")} unanswered probes`}>
          <TriangleAlert size={12} aria-hidden="true" />
          {unanswered.toLocaleString("en-IN")}<span className="sr-only"> unanswered probes</span>
        </span>}
      </span>
      <span title={health.last_measured_at || undefined}>
        {health.last_measured_at ? `Measured ${ago(health.last_measured_at)}` : "Measurement time unavailable"}
      </span>
    </Link>
  );
}
